/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, July 7th 2022, 6:52:48 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { TaskTemplate } from "lib/schemas";
import { ProcessStageInput } from "service-builder/components/stages/ProcessStageInput";

export const TaskStageSettings = () => {
  return <ProcessStageInput<TaskTemplate> schema_field_key="stage" />;
};
